let draw = (chart, x) => {
  if (!isNaN(x)) {
    let ctx = chart.chart.ctx
    let chartArea = chart.chartArea

    ctx.save()
    ctx.beginPath()
    ctx.lineWidth = chart.options.verticalCursor.borderWidth
    ctx.strokeStyle = chart.options.verticalCursor.borderColor
    ctx.moveTo(x, chartArea.bottom)
    ctx.lineTo(x, chartArea.top)
    ctx.stroke()
    ctx.restore()
  }
}

let nearestX = (chart, dataIndex, eventX) => {
  let meta = chart.getDatasetMeta(dataIndex).data

  let xs = meta.map((m) => {
    return m._model.x
  })

  return xs.reduce((prev, curr) => {
    return (Math.abs(curr - eventX) < Math.abs(prev - eventX) ? curr : prev)
  }, 0)
}

export default {
  afterEvent: function (chart, e) {
    if (e.type === 'mousemove') {
      chart.options.verticalCursor.x = nearestX(chart, chart.options.verticalCursor.dataIndex, e.x)
    } else if (e.type === 'mouseout') {
      chart.options.verticalCursor.x = undefined
    }
  },
  afterDatasetsDraw: function (chart, easing) {
    draw(chart, chart.options.verticalCursor.x)
  }
}
